<script>
	export let book;
	export let noCover;
	import { onMount } from 'svelte';

	let coverEl;
	let bookTitleEl;
	let bookAuthorEl;
	let cover = book && book.cover ? HOST + book.cover : noCover;
	let href = book && book.shortId ? `${HOST}/b/${book.shortId}` : undefined;

	onMount(() => {
		if(book) {
			window.$clamp(bookTitleEl, {clamp: 3});
			window.$clamp(bookAuthorEl, {clamp: 1});
			if(!book.cover) {
				coverEl.style.backgroundSize = "85%"
			}
			observeBookImages();
		}
	});

	function observeBookImages() {
        var options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.2
        }
        var callback = function(entries, observer) {
            entries.forEach((entry) => {
                if(entry.isIntersecting) {
                	entry.target.style.backgroundImage = `url(${cover})`
                    observer.unobserve(entry.target)
                }
            })
        }
        var observer = new IntersectionObserver(callback, options);
        coverEl && observer.observe(coverEl)
    }
</script>

{#if book}
	<a class="book" target="_blank" { href }>
		<div class="cover" 	bind:this={coverEl}></div>
		<h3  class="title" 	title={book.title} bind:this={bookTitleEl}>{book.title}</h3>
		<h4  class="author" title={book.author} bind:this={bookAuthorEl}>{book.author}</h4>
	</a>
{/if}

<style>
	.book {
		max-width: 190px;
		min-width: 150px;
		margin: 0 12px 19px;
		flex: .9 1.1 16%;
		display: block;
	}
	.cover {
		background-color: #e2e2e2;
		background-size: cover;
		background-position: center center;
		padding-top: 150%;
		margin-bottom: 8px;
		border-radius: 3px;
		box-shadow: 0 0 10px rgba(0,0,0,0.1) inset;
	}
	.title {
		font-weight: 700;
		font-size: 0.85em;
		color: rgb(53, 53, 53);
		margin: 0
	}
	.author {
		font-weight: normal;
		font-size: 0.8em;
		color: rgb(102,102,102);
		margin: 0;
	}
</style>